import { Routes, Route } from 'react-router-dom';
import { HomePage } from '@/components/HomePage';
import { SpeakerPage } from '@/components/SpeakerPage';
import { SimpleSpeakerRoom } from '@/components/SimpleSpeakerRoom';
import { ListenerPage } from '@/components/ListenerPage';
import { JoinRoomPage } from '@/components/JoinRoomPage';
import { ErrorBoundary } from '@/components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-background">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/speaker" element={<SpeakerPage />} />
          <Route path="/speaker/:roomId" element={<SpeakerPage />} />
          <Route path="/simple" element={<SimpleSpeakerRoom />} />
          <Route path="/listener" element={<JoinRoomPage />} />
          <Route path="/listener/:roomId" element={<ListenerPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
    </ErrorBoundary>
  );
}

export default App
